// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__bKeaa"};